
function getItem(key) {
    try {
        return sessionStorage.getItem(key);
    } catch (err) {
        return null;
    }
}
function setItem(key, val) {
    if (val==null){
        sessionStorage.removeItem(key);
    }else {
        sessionStorage.setItem(key, val);
    }
}
function getTime(key) {
    var oauthTime=getItem(key)
    if(oauthTime==null){
        return 0
    }else {
        return Number(oauthTime)
    }
}



export default {
    removeItem:function (key) {
        sessionStorage.removeItem(key);
    },
    setItem:function (key, val) {
        setItem(key, val)
    },
    getItem:function (key) {
        return getItem(key)
    },
    // 是否微信
    isWx:function () {
        return /micromessenger/i.test(navigator.userAgent.toLowerCase())
    },
    isComWx:function () {
        return /wxwork/i.test(navigator.userAgent.toLowerCase())
    },
    isMobile:function () {
        return window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    },
    isIOS:function () {
        return window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad)/i);
    },
    isAndroid:function () {
        return window.navigator.userAgent.match(/(Android)/i);
    },
    // 获取浏览器类型
    getBrowserType: function() {
        var ua = navigator.userAgent.toLowerCase();
        if (
            ua.match(/wxwork/i) == "wxwork" &&
            ua.match(/MicroMessenger/i) == "micromessenger"
        ) {
            return "wxwork";
        } else if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return "wx";
        } else {
            return "other";
        }
    }
};
